import React from 'react';

import { NotesPanel } from '@/components/NotesPanel';
import { Sheet, SheetContent } from '@/components/ui/sheet';

interface ViewNotesSheetProps {
  isOpen: boolean;
  onClose: () => void;
  caseRecordId: string;
  canAddNote: boolean;
}

export function ViewNotesSheet({ isOpen, onClose, caseRecordId, canAddNote }: ViewNotesSheetProps) {
  return (
    <Sheet open={isOpen} onOpenChange={open => !open && onClose()}>
      <SheetContent
        className="w-[400px] sm:w-[450px] p-0 pr-6 pt-1.5"
        onPointerDownOutside={e => e.stopPropagation()}
        onInteractOutside={e => e.stopPropagation()}
        onCloseAutoFocus={e => e.preventDefault()}
      >
        <NotesPanel caseRecordId={caseRecordId} canAddNote={canAddNote} />
      </SheetContent>
    </Sheet>
  );
}
